@if (data()) {
  <div
    class="ui-grid-cell-contents d-flex align-items-center"
    irisDragAndDrop
    [droppable]="isDroppable"
    [draggable]="isDraggable"
    [dragData]="dragData()"
    [dropData]="dropData"
    [draggingPicture]="draggingPicture()"
    [handlerElements]="handlerElements"
    (dragStart)="dragStarted()"
    (dragEnd)="dragEnded()"
    (dropped)="dataDropped($event)"
    (mousedown)="onMouseDown($event)"
  >
    @if(shouldShowActionGoToFolder()) {
      <sk-button
        [appearance]="'icon'"
        (click)="openFileInParentFolder($event)"
        [matTooltip]="'label.dms.GoToFolder' | translate"
        data-test="dms-grid-name-template-go-to-folder-button"
      >
        <em class="fas fa-external-link-alt icon"></em>
      </sk-button>
    }
    <a
      href="javascript:void(0)"
      draggable="false"
      (dblclick)="onDblClick($event)"
      (click)="onClick($event)"
      class="file-link"
      data-test="dms-grid-name-template-link"
    >
      <div class="d-flex align-items-center">
        <em
          [hidden]="!!folder()"
          class="icon-iris fa-3x dms-icon-color file-preview"
          [ngClass]="fileIcon()"
          [style.font-size]="previewSize + 'px'"
        ></em>

        <em [hidden]="folder() || !file()?.isLocked" class="fas fa-lock lock-icon"></em>

        @if (!!folder() && !folder()?.customIconClass) {
          <iris-folder-svg
            class="folder-preview"
            [folder]="folder()"
            width="30"
            height="30"
          ></iris-folder-svg>
        }

        @if (!!folder()?.customIconClass) {
          <em class="flag-icon" [class]="folder()?.customIconClass" [style.color]="folder()?.normilizedColor"></em>
        }

        @if (isFileLinked) {
          <em class="icon fas fa-fw fa-link me-1" [matTooltip]="fileLinksTooltip | translate"></em>
        }

        <div class="data-name"
          [matTooltip]="nameTooltip() | translate"
          matTooltipPosition="after"
          [matTooltipDisabled]="!!folder()"
          [style.padding-left.px]="folder()?.customIconClass ? 54 : 0">{{ data()?.name }}</div>
      </div>
    </a>
  </div>
}
